"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable no-param-reassign */
var redux_1 = require("redux");
var BrandType_1 = require("../../types/enums/BrandType");
var pagination = __importStar(require("../../utils/Pagination"));
var constants_1 = require("./constants");
var api_1 = require("../../utils/api");
var getEpisode_1 = __importDefault(require("./queries/getEpisode"));
var reducers = {
    brandById: api_1.createCustomModuleReducer(__assign(__assign(__assign(__assign(__assign({}, api_1.createApiReducer({
        actionType: constants_1.FETCH_BRAND,
        onSuccess: function (draftState, action) {
            var _a = action.meta, isShow = _a.isShow, isPpv = _a.isPpv;
            var type;
            if (isPpv) {
                type = 'payPerViewEvent';
            }
            else {
                type = isShow ? 'show' : 'movie';
            }
            var brand = action.payload[type];
            if (brand) {
                draftState.data[action.meta.brandId] = brand;
            }
        },
    })), (_a = {}, _a[constants_1.SET_BRAND] = function (state, action) {
        var _a;
        state.data[(_a = action.payload) === null || _a === void 0 ? void 0 : _a.id] = action.payload;
    }, _a)), api_1.createApiReducer({
        actionType: constants_1.FETCH_DEFAULT_EPISODE,
        onSuccess: function (draftState, action) {
            var brand = action.payload.show;
            if (brand) {
                var draftBrand = draftState.data[brand.id];
                if (draftBrand && draftBrand.__typename === BrandType_1.BrandType.Show) {
                    draftBrand.defaultEpisode = brand.defaultEpisode;
                }
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.FETCH_SHOW_HIGHLIGHTS,
        onRequest: function (draftState, action) {
            var brandId = action.meta.brandId;
            var draftBrand = draftState.data[brandId];
            if ((draftBrand === null || draftBrand === void 0 ? void 0 : draftBrand.__typename) === BrandType_1.BrandType.Show && draftBrand.highlights) {
                pagination.reducerOnRequest(draftBrand.highlights);
            }
        },
        onSuccess: function (draftState, action) {
            var _a;
            var result = (_a = action.payload.show) === null || _a === void 0 ? void 0 : _a.highlights;
            var brandId = action.meta.brandId;
            var draftBrand = draftState.data[brandId];
            if ((draftBrand === null || draftBrand === void 0 ? void 0 : draftBrand.__typename) === BrandType_1.BrandType.Show && draftBrand.highlights) {
                pagination.reducerOnSuccess(draftBrand.highlights, result);
            }
        },
        onFailure: function (draftState, action) {
            var brandId = action.meta.brandId;
            var draftBrand = draftState.data[brandId];
            if ((draftBrand === null || draftBrand === void 0 ? void 0 : draftBrand.__typename) === BrandType_1.BrandType.Show && draftBrand.highlights) {
                pagination.reducerOnFailure(draftBrand.highlights, action.payload);
            }
        },
    })), api_1.createApiReducer({
        actionType: constants_1.MY_LIST,
        onSuccess: function (draftState, action) {
            var _a = action.meta, brandId = _a.brandId, isAdded = _a.isAdded;
            var brand = draftState.data[brandId];
            if (brand) {
                brand.onMyList = isAdded;
            }
        },
        onFailure: function (draftState, action) {
            var brandId = action.meta.brandId;
            var brand = draftState.data[brandId];
            if (brand) {
                brand.onMyList = false;
            }
            draftState.error = 'my-list';
        },
    })), api_1.createApiInitialState({})),
    selectedSeasonByBrandId: api_1.createCustomModuleReducer((_b = {},
        _b[constants_1.SELECT_SEASON] = function (draftState, action) {
            var _a = action.payload, brandId = _a.brandId, selectedSeasonId = _a.selectedSeasonId;
            if (brandId && selectedSeasonId) {
                draftState[brandId] = selectedSeasonId;
            }
        },
        _b), {}),
    episodeById: api_1.createCustomModuleReducer(__assign({}, api_1.createApiReducer({
        actionType: getEpisode_1.default,
        onSuccess: function (draftState, action) {
            var _a;
            draftState.data = (_a = action.payload) === null || _a === void 0 ? void 0 : _a.episode;
        },
    })), api_1.createApiInitialState({})),
};
exports.default = redux_1.combineReducers(reducers);
//# sourceMappingURL=reducer.js.map